import React from 'react';
import DocumentModuleV2 from './DocumentModuleV2';

export default function PurchasesV2() {
  return (
    <DocumentModuleV2
      kind="purchases"
      title="Purchases"
      counterpartyLabel="Supplier"
    />
  );
}
